// dataLoader.js - Fixed to load from all_access_destinations.json
import allAccessDestinations from './all_access_destinations.json';

const loadCountriesFromFile = async () => {
    try {
        console.log('📁 Loading countries from all_access_destinations.json...');

        // Use the imported JSON file directly
        if (allAccessDestinations && Array.isArray(allAccessDestinations)) {
            const countriesList = allAccessDestinations
                .filter(country => country && country.trim().length > 0)
                .sort();

            console.log(`✅ Loaded ${countriesList.length} countries from all_access_destinations.json`);
            console.log('📋 Sample countries:', countriesList.slice(0, 10));
            return countriesList;
        } else {
            throw new Error('Invalid JSON structure in all_access_destinations.json');
        }
    } catch (error) {
        console.log('❌ Error loading countries from JSON file:', error.message);

        // Try to fetch from public folder as fallback
        try {
            console.log('🔄 Trying to fetch from public folder...');
            const response = await fetch('/all_access_destinations.json');
            if (response.ok) {
                const jsonData = await response.json();
                if (Array.isArray(jsonData)) {
                    const countriesList = jsonData
                        .filter(country => country && country.trim().length > 0)
                        .sort();

                    console.log(`✅ Loaded ${countriesList.length} countries from public/all_access_destinations.json`);
                    return countriesList;
                } else {
                    throw new Error('Invalid JSON structure from public folder');
                }
            } else {
                console.log('❌ Could not fetch all_access_destinations.json from public folder');
            }
        } catch (fetchError) {
            console.log('❌ Error fetching from public folder:', fetchError.message);
        }
    }

    // Final fallback - minimal country list
    const fallbackCountries = [
        'Afghanistan', 'Albania', 'Algeria', 'Angola', 'Argentina', 'Armenia', 'Australia',
        'Austria', 'Azerbaijan', 'Bahrain', 'Bangladesh', 'Belgium', 'Bolivia', 'Brazil',
        'Bulgaria', 'Cambodia', 'Cameroon', 'Canada', 'Chad', 'Chile', 'China', 'Colombia',
        'Croatia', 'Cyprus', 'Czech Republic', 'Denmark', 'Ecuador', 'Egypt', 'Estonia',
        'Ethiopia', 'Finland', 'France', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Guatemala',
        'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel',
        'Italy', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Latvia', 'Lebanon',
        'Libya', 'Lithuania', 'Luxembourg', 'Malaysia', 'Malta', 'Mexico', 'Morocco',
        'Myanmar', 'Nepal', 'Netherlands', 'New Zealand', 'Nigeria', 'North Macedonia',
        'Norway', 'Oman', 'Pakistan', 'Peru', 'Philippines', 'Poland', 'Portugal',
        'Qatar', 'Romania', 'Russia', 'Saudi Arabia', 'Serbia', 'Singapore', 'Slovakia',
        'Slovenia', 'Somalia', 'South Africa', 'South Korea', 'Spain', 'Sri Lanka',
        'Sudan', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tanzania', 'Thailand',
        'Tunisia', 'Turkey', 'Ukraine', 'United Arab Emirates', 'United Kingdom',
        'United States', 'Uruguay', 'Venezuela', 'Vietnam', 'Yemen', 'Zimbabwe'
    ];

    console.log(`⚠️ Using ${fallbackCountries.length} fallback countries (file loading failed)`);
    return fallbackCountries;
};

const loadOriginsFromFile = async () => {
    try {
        // Try to fetch from public folder first
        const response = await fetch('/Daily_sid_gather.txt');
        if (response.ok) {
            const fileContent = await response.text();
            const originsList = fileContent
                .split('\n')
                .map(origin => origin.trim())
                .filter(origin => origin.length > 0)
                .sort();

            console.log(`✅ Loaded ${originsList.length} origins from Daily_sid_gather.txt`);
            return originsList;
        } else {
            console.log('❌ Could not fetch Daily_sid_gather.txt from public folder');
        }
    } catch (error) {
        console.log('❌ Error loading origins file:', error.message);
    }

    // Fallback origins only if file completely fails
    const fallbackOrigins = [
        'Apple', 'Google', 'Microsoft', 'Amazon', 'Facebook', 'Netflix', 'Spotify',
        'PayPal', 'Uber', 'Airbnb', 'Twitter', 'Instagram', 'LinkedIn', 'GitHub',
        'Discord', 'Telegram', 'WhatsApp', 'Zoom', 'Slack', 'Dropbox', 'Adobe',
        'Oracle', 'Samsung', 'Sony', 'Nintendo', 'Tesla', 'Coinbase', 'Binance',
        'Steam', 'Epic Games', 'Roblox', 'TikTok', 'YouTube', 'Twitch', 'Reddit'
    ];

    console.log(`⚠️ Using ${fallbackOrigins.length} fallback origins (file not found)`);
    return fallbackOrigins;
};

// Export as both named exports and as an object
export { loadCountriesFromFile, loadOriginsFromFile };

export const dataLoader = {
    loadCountriesFromFile,
    loadOriginsFromFile
};